<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <header-padrao class="mb-2" icon="fa fa-sitemap" :titulo="tituloTela">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-key mr-1 text-info"></i>
              ID: <strong class="text-white">{{ cabecalho.ID || id }}</strong>
            </span>
            <span v-if="cabecalho.LOTE" class="text-white-50">Lote {{ cabecalho.LOTE }}</span>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="exportarExcel">
            <i class="fa fa-file-excel-o mr-1"></i> Excel
          </b-button>
          <b-button variant="link" class="btn-glass px-4 font-weight-bold ml-2" @click.stop.prevent="exportarCsv">
            <i class="fa fa-file-text-o mr-1"></i> CSV
          </b-button>
          <b-button variant="dark" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="imprimirEspelho">
            <i class="fa fa-print mr-1"></i> ESPELHO
          </b-button>
          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </header-padrao>

      <b-row class="px-2">
        <b-col sm="12">
          <b-card class="shadow-sm mb-3" :class="{'bg-dark border-secondary': isDark}">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center section-icon">
                  <i class="fa fa-cube"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">{{ tituloCabecalho }}</h6>
                  <small class="text-muted">{{ subtituloCabecalho }}</small>
                </div>
              </div>
            </template>

            <b-row>
              <b-col md="4">
                <label class="modal-label-premium">Lote</label>
                <b-form-input :value="cabecalho.LOTE || ''" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado"></b-form-input>
              </b-col>
              <b-col md="5">
                <label class="modal-label-premium">Produto</label>
                <b-form-input :value="cabecalhoProduto" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado"></b-form-input>
              </b-col>
              <b-col md="3">
                <label class="modal-label-premium">Centro</label>
                <b-form-input :value="cabecalhoCentro" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado"></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-3" v-if="tipoConsulta === 'FINAL'">
              <b-col md="4">
                <label class="modal-label-premium">Processo</label>
                <b-form-input :value="cabecalho.PROCESSO_ID || ''" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado"></b-form-input>
              </b-col>
              <b-col md="8">
                <label class="modal-label-premium">Fórmula</label>
                <b-form-input :value="cabecalho.FORMULA_DESCRICAO || ''" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado"></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col md="3" v-if="cabecalho.LOTE_FORNECEDOR">
                <label class="modal-label-premium">Lote Fornecedor</label>
                <b-form-input :value="cabecalho.LOTE_FORNECEDOR || ''" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado"></b-form-input>
              </b-col>
              <b-col md="3" v-if="cabecalho.DATA_FABRICACAO">
                <label class="modal-label-premium">Fabricação</label>
                <b-form-input :value="formatarData(cabecalho.DATA_FABRICACAO)" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado"></b-form-input>
              </b-col>
              <b-col md="3" v-if="cabecalho.DATA_VALIDADE">
                <label class="modal-label-premium">Validade</label>
                <b-form-input :value="formatarData(cabecalho.DATA_VALIDADE)" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado"></b-form-input>
              </b-col>
              <b-col md="3" v-if="cabecalho.DATA_CADASTRO">
                <label class="modal-label-premium">Cadastro</label>
                <b-form-input :value="formatarDataHora(cabecalho.DATA_CADASTRO)" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado"></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col md="2">
                <div class="trace-resume-card bg-light">
                  <small class="text-muted d-block">Qtd. Inicial</small>
                  <strong>{{ formatarNumero(cabecalho.QUANT_INICIAL) }}</strong>
                </div>
              </b-col>
              <b-col md="2">
                <div class="trace-resume-card bg-light">
                  <small class="text-muted d-block">Qtd. Saldo</small>
                  <strong>{{ formatarNumero(cabecalho.QUANT_SALDO) }}</strong>
                </div>
              </b-col>
              <b-col md="2">
                <div class="trace-resume-card bg-light">
                  <small class="text-muted d-block">Linhas</small>
                  <strong>{{ itens.length }}</strong>
                </div>
              </b-col>
              <b-col md="2">
                <div class="trace-resume-card bg-light border-left border-info">
                  <small class="text-info font-weight-bold d-block">Matéria-Prima</small>
                  <strong class="text-info">{{ formatarMoeda(custoTotalMateriaPrima) }}</strong>
                </div>
              </b-col>
              <b-col md="2" v-if="tipoConsulta === 'FINAL'">
                <div class="trace-resume-card bg-light border-left border-warning">
                  <small class="text-warning font-weight-bold d-block">Custo Operacional</small>
                  <strong class="text-warning">{{ formatarMoeda(cabecalho.CUSTO_OPERACIONAL_TOTAL || 0) }}</strong>
                </div>
              </b-col>
              <b-col md="2" v-if="tipoConsulta === 'FINAL'">
                <div class="trace-resume-card bg-dark text-white rounded">
                  <small class="text-white-50 d-block">Custo Unitário (KG)</small>
                  <strong class="text-success">{{ formatarMoeda(custoUnitarioKg) }}</strong>
                </div>
              </b-col>
            </b-row>
          </b-card>

          <b-card class="shadow-sm mb-3" :class="{'bg-dark border-secondary': isDark}" v-if="tipoConsulta === 'FINAL' && dadosGraficoCustos && dadosGraficoCustos.datasets[0].data.length > 0">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center section-icon">
                  <i class="fa fa-dashboard"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Dashboard Analítico</h6>
                  <small class="text-muted">Análise de Custos, Quantidades e Cadeia de Fornecimento do Lote</small>
                </div>
              </div>
            </template>
            
            <b-row>
              <b-col lg="4" md="12" class="mb-4 mb-lg-0">
                <h6 class="text-center font-weight-bold mb-3 small text-muted text-uppercase">Custo por Matéria-Prima</h6>
                <div style="height: 250px; position: relative;">
                  <grafico-custos-rastreabilidade :chart-data="dadosGraficoCustos"></grafico-custos-rastreabilidade>
                </div>
              </b-col>
              <b-col lg="4" md="12" class="mb-4 mb-lg-0 border-left border-right">
                <h6 class="text-center font-weight-bold mb-3 small text-muted text-uppercase">Quantidade Consumida (kg)</h6>
                <div style="height: 250px; position: relative;">
                  <grafico-quantidade-rastreabilidade :chart-data="dadosGraficoQuantidade"></grafico-quantidade-rastreabilidade>
                </div>
              </b-col>
              <b-col lg="4" md="12">
                <h6 class="text-center font-weight-bold mb-3 small text-muted text-uppercase">Origem por Fornecedor (Qtd)</h6>
                <div style="height: 250px; position: relative;">
                  <grafico-fornecedor-rastreabilidade :chart-data="dadosGraficoFornecedor"></grafico-fornecedor-rastreabilidade>
                </div>
              </b-col>
            </b-row>
          </b-card>

          <b-card class="shadow-sm mb-3" :class="{'bg-dark border-secondary': isDark}">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center section-icon">
                  <i class="fa fa-random"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">{{ tituloTabela }}</h6>
                  <small class="text-muted">{{ subtituloTabela }}</small>
                </div>
              </div>
            </template>

            <b-table
              :items="itens"
              :fields="fieldsAtuais"
              responsive
              hover
              small
              show-empty
              :busy.sync="isBusy"
              empty-text="Nenhum vínculo de rastreabilidade encontrado"
              class="mb-0 table-finance">

              <template #cell(LOTE_MATERIA_PRIMA)="row">
                <a href="#" @click.prevent="carregarRastreabilidadeMP(row.item.ESTOQUE_LOTE_MATERIA_PRIMA_ID)" class="font-weight-bold text-primary">
                  {{ row.item.LOTE_MATERIA_PRIMA }}
                </a>
              </template>

              <template #cell(DATA_CONSUMO)="row">
                <span>{{ formatarDataHora(row.item.DATA_CONSUMO) }}</span>
              </template>

              <template #cell(DATA_ENTRADA_FINAL)="row">
                <span>{{ formatarDataHora(row.item.DATA_ENTRADA_FINAL) }}</span>
              </template>

              <template #cell(QUANT_CONSUMIDA)="row">
                <span class="text-right d-block">{{ formatarNumero(row.item.QUANT_CONSUMIDA) }}</span>
              </template>

              <template #cell(CUSTO_TOTAL)="row">
                <span class="text-right d-block">{{ formatarNumero(row.item.CUSTO_TOTAL) }}</span>
              </template>

              <template #cell(QUANTIDADE_FINAL_APONTAMENTO)="row">
                <span class="text-right d-block">{{ formatarNumero(row.item.QUANTIDADE_FINAL_APONTAMENTO) }}</span>
              </template>

              <template #cell(QUANT_PRODUZIDA_APONTAMENTO)="row">
                <span class="text-right d-block">{{ formatarNumero(row.item.QUANT_PRODUZIDA_APONTAMENTO) }}</span>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import { printHtmlReport, exportExcelXlsx, exportCsv } from '@/utils/RelatorioHTML'
import GraficoCustosRastreabilidade from './GraficoCustosRastreabilidade.vue'
import GraficoQuantidadeRastreabilidade from './GraficoQuantidadeRastreabilidade.vue'
import GraficoFornecedorRastreabilidade from './GraficoFornecedorRastreabilidade.vue'

export default {
  components: {
    HeaderPadrao,
    GraficoCustosRastreabilidade,
    GraficoQuantidadeRastreabilidade,
    GraficoFornecedorRastreabilidade
  },
  props: {
    tipo: {
      type: String,
      default: 'mp'
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isBusy: false,
      fieldsMateriaPrima: [
        { key: 'PROCESSO_ID', label: 'Processo', sortable: true, class: 'text-center', thStyle: { width: '90px' } },
        { key: 'FORMULA_DESCRICAO', label: 'Fórmula', sortable: true },
        { key: 'PRODUTO_FINAL_CODIGONOME', label: 'Produto Final', sortable: true },
        { key: 'CENTRO_PRODUCAO_CODIGONOME', label: 'Centro Produção', sortable: true },
        { key: 'LOTE_FINAL', label: 'Lote Final', sortable: true, thStyle: { width: '140px' } },
        { key: 'APONTAMENTO_ID', label: 'Apont.', sortable: true, class: 'text-center', thStyle: { width: '85px' } },
        { key: 'DATA_CONSUMO', label: 'Data Consumo', sortable: true, thStyle: { width: '145px' } },
        { key: 'DATA_ENTRADA_FINAL', label: 'Entrada Lote Final', sortable: true, thStyle: { width: '145px' } },
        { key: 'QUANT_CONSUMIDA', label: 'Qtd. Consumida', sortable: true, class: 'text-right', thStyle: { width: '120px' } },
        { key: 'PECAS_CONSUMIDAS', label: 'Peças', sortable: true, class: 'text-center', thStyle: { width: '80px' } },
        { key: 'CUSTO_TOTAL', label: 'Custo Total', sortable: true, class: 'text-right', thStyle: { width: '120px' } },
        { key: 'QUANTIDADE_FINAL_APONTAMENTO', label: 'Qtd. Final', sortable: true, class: 'text-right', thStyle: { width: '110px' } },
        { key: 'PECAS_FINAL_APONTAMENTO', label: 'Peças Final', sortable: true, class: 'text-center', thStyle: { width: '90px' } }
      ],
      fieldsFinal: [
        { key: 'LOTE_MATERIA_PRIMA', label: 'Lote MP', sortable: true, thStyle: { width: '140px' } },
        { key: 'LOTE_FORNECEDOR', label: 'Lote Fornec.', sortable: true, thStyle: { width: '140px' } },
        { key: 'PROD_MATERIA_PRIMA_CODIGONOME', label: 'Matéria-Prima', sortable: true },
        { key: 'CENTRO_ESTOQUE_CODIGONOME', label: 'Centro Estoque', sortable: true },
        { key: 'APONTAMENTO_ID', label: 'Apont.', sortable: true, class: 'text-center', thStyle: { width: '85px' } },
        { key: 'DATA_CONSUMO', label: 'Data Consumo', sortable: true, thStyle: { width: '145px' } },
        { key: 'DATA_ENTRADA_FINAL', label: 'Entrada Lote Final', sortable: true, thStyle: { width: '145px' } },
        { key: 'QUANT_CONSUMIDA', label: 'Qtd. Consumida', sortable: true, class: 'text-right', thStyle: { width: '120px' } },
        { key: 'PECAS_CONSUMIDAS', label: 'Peças', sortable: true, class: 'text-center', thStyle: { width: '80px' } },
        { key: 'CUSTO_TOTAL', label: 'Custo Total', sortable: true, class: 'text-right', thStyle: { width: '120px' } },
        { key: 'QUANT_PRODUZIDA_APONTAMENTO', label: 'Qtd. Produzida', sortable: true, class: 'text-right', thStyle: { width: '120px' } },
        { key: 'PECAS_PRODUZIDAS_APONTAMENTO', label: 'Peças Produz.', sortable: true, class: 'text-center', thStyle: { width: '95px' } }
      ]
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    detalhe() { return this.$store.getters['producaoFormulaRastreabilidade/DETALHE'] || {} },
    tipoConsulta() {
      return String(this.tipo || '').toLowerCase() === 'final' ? 'FINAL' : 'MP'
    },
    cabecalho() {
      return this.detalhe.cabecalho || {}
    },
    itens() {
      return this.detalhe.itens || []
    },
    dadosGraficoCustos() {
      if (this.tipoConsulta !== 'FINAL' || !this.itens.length) return null
      
      const agrupado = this.itens.reduce((acc, item) => {
        const nome = item.PROD_MATERIA_PRIMA_CODIGONOME || 'Desconhecido'
        if (!acc[nome]) {
          acc[nome] = 0
        }
        acc[nome] += Number(item.CUSTO_TOTAL || 0)
        return acc
      }, {})

      const labels = Object.keys(agrupado)
      const data = Object.values(agrupado)
      
      const bgColors = [
        '#339af0', '#51cf66', '#fcc419', '#ff922b', '#ff6b6b', 
        '#cc5de8', '#845ef7', '#20c997', '#94d82d', '#f06595'
      ]
      
      const backgroundColors = labels.map((_, index) => bgColors[index % bgColors.length])

      return {
        labels,
        datasets: [
          {
            data,
            backgroundColor: backgroundColors,
            borderWidth: 1
          }
        ]
      }
    },
    dadosGraficoQuantidade() {
      if (this.tipoConsulta !== 'FINAL' || !this.itens.length) return null
      
      const agrupado = this.itens.reduce((acc, item) => {
        const nome = item.PROD_MATERIA_PRIMA_CODIGONOME || 'Desconhecido'
        if (!acc[nome]) {
          acc[nome] = 0
        }
        acc[nome] += Number(item.QUANT_CONSUMIDA || 0)
        return acc
      }, {})

      const labels = Object.keys(agrupado)
      const data = Object.values(agrupado)
      const bgColors = ['#4dbd74', '#20a8d8', '#ffc107', '#f86c6b', '#63c2de', '#f8cb00', '#20c997']
      const backgroundColors = labels.map((_, index) => bgColors[index % bgColors.length])

      return {
        labels,
        datasets: [
          {
            label: 'Qtd. Consumida (kg)',
            data,
            backgroundColor: backgroundColors,
            borderWidth: 1
          }
        ]
      }
    },
    dadosGraficoFornecedor() {
      if (this.tipoConsulta !== 'FINAL' || !this.itens.length) return null
      
      const agrupado = this.itens.reduce((acc, item) => {
        const nomeFornec = String(item.LOTE_FORNECEDOR || '').trim() || 'Sem Fornecedor'
        if (!acc[nomeFornec]) {
          acc[nomeFornec] = 0
        }
        acc[nomeFornec] += Number(item.QUANT_CONSUMIDA || 0)
        return acc
      }, {})

      const labels = Object.keys(agrupado)
      const data = Object.values(agrupado)
      const bgColors = ['#f86c6b', '#ffc107', '#4dbd74', '#20a8d8', '#6610f2', '#e83e8c']
      const backgroundColors = labels.map((_, index) => bgColors[index % bgColors.length])

      return {
        labels,
        datasets: [
          {
            data,
            backgroundColor: backgroundColors,
            borderWidth: 1
          }
        ]
      }
    },
    resumo() {
      return this.detalhe.resumo || {}
    },
    fieldsAtuais() {
      return this.tipoConsulta === 'FINAL' ? this.fieldsFinal : this.fieldsMateriaPrima
    },
    tituloTela() {
      return this.tipoConsulta === 'FINAL'
        ? 'RASTREABILIDADE DO LOTE FINAL'
        : 'RASTREABILIDADE DA MATÉRIA-PRIMA'
    },
    tituloCabecalho() {
      return this.tipoConsulta === 'FINAL' ? 'Lote Final Selecionado' : 'Lote de Matéria-Prima Selecionado'
    },
    subtituloCabecalho() {
      return this.tipoConsulta === 'FINAL'
        ? 'Cabeçalho do lote acabado e do processo que o gerou.'
        : 'Cabeçalho do lote consumido e seu saldo atual em estoque.'
    },
    tituloTabela() {
      return this.tipoConsulta === 'FINAL' ? 'Lotes de Matéria-Prima Consumidos' : 'Processos e Lotes Finais Relacionados'
    },
    subtituloTabela() {
      return this.tipoConsulta === 'FINAL'
        ? 'Cada linha representa um lote de matéria-prima consumido nos apontamentos que formaram o lote final.'
        : 'Cada linha representa o consumo deste lote em um apontamento e o respectivo lote final gerado.'
    },
    cabecalhoProduto() {
      return this.tipoConsulta === 'FINAL'
        ? (this.cabecalho.PRODUTO_FINAL_CODIGONOME || '')
        : (this.cabecalho.PRODUTO_CODIGONOME || '')
    },
    cabecalhoCentro() {
      return this.tipoConsulta === 'FINAL'
        ? (this.cabecalho.CENTRO_PRODUCAO_CODIGONOME || '')
        : (this.cabecalho.CENTRO_ESTOQUE_CODIGONOME || '')
    },
    resumoApontamentos() {
      return this.tipoConsulta === 'FINAL'
        ? (this.resumo.totalApontamentos || 0)
        : (this.resumo.totalProcessos || 0)
    },
    resumoSecundario() {
      return this.tipoConsulta === 'FINAL'
        ? (this.resumo.totalLotesMateriaPrima || 0)
        : (this.resumo.totalLotesFinais || 0)
    },
    rotuloResumoFinal() {
      return this.tipoConsulta === 'FINAL' ? 'Apontamentos' : 'Processos'
    },
    rotuloResumoSecundario() {
      return this.tipoConsulta === 'FINAL' ? 'Lotes MP' : 'Lotes Finais'
    },
    tituloExportacao() {
      return this.tipoConsulta === 'FINAL'
        ? `Rastreabilidade do Lote Final ${this.cabecalho.LOTE || this.id}`
        : `Rastreabilidade da Matéria-Prima ${this.cabecalho.LOTE || this.id}`
    },
    custoTotalMateriaPrima() {
      return this.itens.reduce((acc, i) => acc + Number(i.CUSTO_TOTAL || 0), 0)
    },
    custoUnitarioKg() {
      const custoOperacional = Number(this.cabecalho.CUSTO_OPERACIONAL_TOTAL || 0)
      const custoGeral = this.custoTotalMateriaPrima + custoOperacional
      const producaoTotal = Number(this.cabecalho.QUANT_PRODUZIDA || this.cabecalho.QUANT_INICIAL || 1)
      if (producaoTotal <= 0) return 0
      return custoGeral / producaoTotal
    }
  },
  mounted() {
    this.carregarTela()
  },
  watch: {
    '$route.params': {
      handler(newParams, oldParams) {
        if (newParams.id !== oldParams.id || newParams.tipo !== oldParams.tipo) {
          this.carregarTela()
        }
      },
      deep: true
    }
  },
  methods: {
    carregarRastreabilidadeMP(id) {
      if (!id) return
      this.$router.push(`/producao/formula-rastreabilidade/cadastro/mp/${id}`)
    },
    formatarNumero(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatarMoeda(valor) {
      return Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatarData(valor) {
      return valor ? moment(valor).format('DD/MM/YYYY') : ''
    },
    formatarDataHora(valor) {
      return valor ? moment(valor).format('DD/MM/YYYY HH:mm') : ''
    },
    getColunasExportacao() {
      return this.fieldsAtuais.map(campo => ({
        ...campo,
        formatter: undefined
      }))
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itens,
        columns: this.getColunasExportacao(),
        filename: `${this.tituloExportacao.replace(/\s+/g, '_').toLowerCase()}.xlsx`
      })
    },
    exportarCsv() {
      exportCsv({
        rows: this.itens,
        columns: this.getColunasExportacao(),
        filename: `${this.tituloExportacao.replace(/\s+/g, '_').toLowerCase()}.csv`
      })
    },
    async obterEmpresaPreferencial() {
      if (this.empresaPreferencial) return this.empresaPreferencial
      try {
        const { data } = await this.$http.get('/api/protected/conferenciaFinanceira/empresa-preferencial')
        this.empresaPreferencial = data || {}
        return this.empresaPreferencial
      } catch (err) {
        return {}
      }
    },
    escapeHtml(unsafe) {
      if (!unsafe && unsafe !== 0) return ''
      return String(unsafe).replace(/[&<"'>]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '"': '&quot;', "'": '&#39;', '>': '&gt;' })[m])
    },
    montarGraficoPizzaHtml(titulo, slices, textoCentro = '') {
      const total = slices.reduce((acc, item) => acc + Number(item.value || 0), 0)
      let acumulado = 0
      const gradiente = total > 0
        ? slices.map(item => {
          const percentual = Number(item.value || 0) / total * 100
          const inicio = acumulado
          const fim = acumulado + percentual
          acumulado = fim
          return `${item.color} ${inicio.toFixed(2)}% ${fim.toFixed(2)}%`
        }).join(', ')
        : '#dfe6eb 0% 100%'

      const legenda = slices.map(item => `
        <div class="pie-legend-item">
          <div class="pie-legend-label">
            <span class="pie-dot" style="background:${item.color};"></span>
            <span>${this.escapeHtml(item.label)}</span>
          </div>
          <strong>${this.escapeHtml(item.formatted)}</strong>
        </div>
      `).join('')

      return `
        <div class="pie-card">
          <div class="pie-title">${this.escapeHtml(titulo)}</div>
          <div class="pie-row">
            <div class="pie-chart" style="background: conic-gradient(${gradiente});">
              <div class="pie-center">${this.escapeHtml(textoCentro)}</div>
            </div>
            <div class="pie-legend">${legenda}</div>
          </div>
        </div>
      `
    },
    montarHtmlEspelho(empresa) {
      const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
      
      const linhasItens = this.itens.map((item, index) => {
        let colunas = ''
        if (this.tipoConsulta === 'MP') {
          colunas = `
            <td>${this.escapeHtml(item.PROCESSO_ID || '')}</td>
            <td>${this.escapeHtml(item.FORMULA_DESCRICAO || '')}</td>
            <td>${this.escapeHtml(item.PRODUTO_FINAL_CODIGONOME || '')}</td>
            <td>${this.escapeHtml(item.LOTE_FINAL || '')}</td>
            <td style="text-align:right;">${this.escapeHtml(this.formatarNumero(item.QUANT_CONSUMIDA || 0))}</td>
            <td style="text-align:right;">${this.escapeHtml(this.formatarNumero(item.CUSTO_TOTAL || 0))}</td>
            <td style="text-align:right;">${this.escapeHtml(this.formatarNumero(item.QUANTIDADE_FINAL_APONTAMENTO || 0))}</td>
          `
        } else {
          colunas = `
            <td>${this.escapeHtml(item.LOTE_MATERIA_PRIMA || '')}</td>
            <td>${this.escapeHtml(item.PROD_MATERIA_PRIMA_CODIGONOME || '')}</td>
            <td>${this.escapeHtml(item.CENTRO_ESTOQUE_CODIGONOME || '')}</td>
            <td style="text-align:right;">${this.escapeHtml(this.formatarNumero(item.QUANT_CONSUMIDA || 0))}</td>
            <td style="text-align:right;">${this.escapeHtml(this.formatarNumero(item.CUSTO_TOTAL || 0))}</td>
            <td style="text-align:right;">${this.escapeHtml(this.formatarNumero(item.QUANT_PRODUZIDA_APONTAMENTO || 0))}</td>
          `
        }

        return `
        <tr>
          <td>${index + 1}</td>
          ${colunas}
        </tr>
      `}).join('')

      const headersGrid = this.tipoConsulta === 'MP' 
        ? `<th>Processo</th><th>Fórmula</th><th>Produto Final</th><th>Lote Final</th><th style="text-align:right;">Qtd Consumida</th><th style="text-align:right;">Custo Total</th><th style="text-align:right;">Qtd Final</th>`
        : `<th>Lote MP</th><th>Matéria-Prima</th><th>Centro</th><th style="text-align:right;">Qtd Consumida</th><th style="text-align:right;">Custo Total</th><th style="text-align:right;">Qtd Produzida</th>`

      const subCabecalho = this.tipoConsulta === 'MP' 
        ? `<div><strong>Matéria-Prima:</strong> ${this.escapeHtml(this.cabecalhoProduto)}</div>`
        : `<div><strong>Lote Final:</strong> ${this.escapeHtml(this.cabecalho.LOTE || '')} - <strong>Produto:</strong> ${this.escapeHtml(this.cabecalhoProduto)}</div>`

      const custoMateriaPrima = this.custoTotalMateriaPrima
      const custoOperacional = Number(this.cabecalho.CUSTO_OPERACIONAL_TOTAL || 0)
      const custoTotalGeral = custoMateriaPrima + custoOperacional
      const producaoTotal = Number(this.cabecalho.QUANT_PRODUZIDA || this.cabecalho.QUANT_INICIAL || 1)
      const custoUnitario = this.custoUnitarioKg

      const qtdLotes = this.tipoConsulta === 'FINAL' ? (this.resumo.totalLotesMateriaPrima || this.itens.length) : (this.resumo.totalLotesFinais || this.itens.length)

      const dadosCustos = this.dadosGraficoCustos
      const dadosQuantidades = this.dadosGraficoQuantidade
      const dadosFornecedores = this.dadosGraficoFornecedor
      
      const graficoCustos = dadosCustos ? this.montarGraficoPizzaHtml('Custo por Matéria-Prima', dadosCustos.labels.map((lbl, idx) => ({
        label: lbl,
        value: dadosCustos.datasets[0].data[idx],
        formatted: Number(dadosCustos.datasets[0].data[idx]).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        color: dadosCustos.datasets[0].backgroundColor[idx]
      })), '') : ''

      const graficoQtd = dadosQuantidades ? this.montarGraficoPizzaHtml('Quantidade Consumida', dadosQuantidades.labels.map((lbl, idx) => ({
        label: lbl,
        value: dadosQuantidades.datasets[0].data[idx],
        formatted: Number(dadosQuantidades.datasets[0].data[idx]).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) + ' kg',
        color: dadosQuantidades.datasets[0].backgroundColor[idx]
      })), '') : ''

      const graficoForn = dadosFornecedores ? this.montarGraficoPizzaHtml('Origem por Fornecedor', dadosFornecedores.labels.map((lbl, idx) => ({
        label: lbl,
        value: dadosFornecedores.datasets[0].data[idx],
        formatted: Number(dadosFornecedores.datasets[0].data[idx]).toLocaleString('pt-BR', { minimumFractionDigits: 2 }),
        color: dadosFornecedores.datasets[0].backgroundColor[idx]
      })), '') : ''

      const blocosDashboard = this.tipoConsulta === 'FINAL' && this.itens.length > 0 
        ? `<div class="section" style="page-break-inside: avoid;">
             <div class="section-title">Dashboard Analítico</div>
             <div class="charts-grid">
               ${graficoCustos}
               ${graficoQtd}
               ${graficoForn}
             </div>
           </div>`
        : ''

      return `<!doctype html>
      <html lang="pt-BR">
      <head>
        <meta charset="utf-8">
        <title>Espelho da Rastreabilidade</title>
        <style>
          body { font-family: Arial, Helvetica, sans-serif; margin: 16px; color: #111; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .report-header { border: 1px solid #2f2f2f; }
          .report-header-top, .report-header-sub { display: flex; justify-content: space-between; padding: 4px 8px; font-size: 11px; border-bottom: 1px solid #2f2f2f; }
          .report-header-title { padding: 4px 8px; font-size: 12px; font-weight: 700; text-transform: uppercase; }
          .section { margin-top: 10px; page-break-inside: avoid; }
          .section-title { font-size: 11px; font-weight: 700; margin-bottom: 4px; text-transform: uppercase; }
          .grid, .info-table { width: 100%; border-collapse: collapse; }
          .grid th, .grid td, .info-table td { border: 1px solid #2f2f2f; padding: 4px 6px; font-size: 11px; vertical-align: top; }
          .grid th { background: #f2f2f2; text-align: left; }
          .info-table td { width: 50%; }
          .kpi-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: 10px; }
          .kpi-card { border: 1px solid #2f2f2f; padding: 8px; }
          .kpi-card small { display:block; font-size:10px; text-transform:uppercase; color:#666; margin-bottom:4px; }
          .kpi-card strong { font-size:16px; }
          .charts-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-top: 10px; }
          .pie-card { border: 1px solid #2f2f2f; padding: 8px; min-height: 180px; }
          .pie-title { font-size: 10px; font-weight: 700; text-transform: uppercase; margin-bottom: 8px; text-align: center; }
          .pie-row { display: flex; flex-direction: column; align-items: center; gap: 10px; }
          .pie-chart { width: 100px; height: 100px; border-radius: 50%; position: relative; flex-shrink: 0; }
          .pie-center { position: absolute; inset: 20px; border-radius: 50%; background: #fff; display: flex; align-items: center; justify-content: center; text-align: center; font-size: 12px; font-weight: 700; }
          .pie-legend { width: 100%; }
          .pie-legend-item { display: flex; justify-content: space-between; align-items: center; font-size: 9px; margin-bottom: 4px; border-bottom: 1px dashed #eee; padding-bottom: 2px; }
          .pie-legend-label { display: flex; align-items: center; gap: 4px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; max-width: 120px; }
          .pie-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; flex-shrink: 0; }
          .report-footer { position: fixed; left: 16px; right: 16px; bottom: 8px; display: flex; justify-content: space-between; font-size: 10px; border-top: 1px solid #2f2f2f; padding-top: 4px; background: #fff; }
          @media print { @page { size: A4 portrait; margin: 10mm; } body { margin: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
        </style>
      </head>
      <body>
        <div class="report-header">
          <div class="report-header-top">
            <div><strong>${this.escapeHtml(empresa.FANTASIA || empresa.RAZAO_RELATORIO || empresa.RAZAO || 'CECWEB')}</strong></div>
            <div><strong>Usuário:</strong> ${this.escapeHtml(nomeUsuario)}</div>
          </div>
          <div class="report-header-title">${this.escapeHtml(this.tituloCabecalho)}</div>
          <div class="report-header-sub">
            <div>${this.escapeHtml(empresa.NOME_EMPRESA || '')}</div>
            <div><strong>Emitido em:</strong> ${this.escapeHtml(this.formatarDataHora(new Date()))}</div>
          </div>
          <div class="report-header-sub" style="border-bottom:0;">
            ${subCabecalho}
          </div>
        </div>

        <div class="section">
          <div class="section-title">Resumo do Lote</div>
          <table class="info-table">
            <tr>
              <td><strong>Lote:</strong> ${this.escapeHtml(this.cabecalho.LOTE || '')}</td>
              <td><strong>Centro:</strong> ${this.escapeHtml(this.cabecalhoCentro || '')}</td>
            </tr>
            <tr>
              <td><strong>Qtd. Inicial:</strong> ${this.escapeHtml(this.formatarNumero(this.cabecalho.QUANT_INICIAL))}</td>
              <td><strong>Qtd. Saldo:</strong> ${this.escapeHtml(this.formatarNumero(this.cabecalho.QUANT_SALDO))}</td>
            </tr>
            <tr>
              <td><strong>Peças Saldo:</strong> ${this.escapeHtml(this.cabecalho.PECAS_SALDO || 0)}</td>
              <td><strong>${this.escapeHtml(this.rotuloResumoFinal)}:</strong> ${this.escapeHtml(this.resumoApontamentos)}</td>
            </tr>
          </table>

          <div class="kpi-grid">
            <div class="kpi-card"><small>Custo Matéria-Prima</small><strong>${this.escapeHtml(Number(custoMateriaPrima).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))}</strong></div>
            <div class="kpi-card"><small>Custo Operacional</small><strong>${this.escapeHtml(Number(custoOperacional).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))}</strong></div>
            <div class="kpi-card"><small>Custo Unitário (KG)</small><strong style="color: #198754;">${this.escapeHtml(Number(custoUnitario).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))}</strong></div>
            <div class="kpi-card"><small>Lotes Envolvidos</small><strong>${this.escapeHtml(this.formatarNumero(qtdLotes))}</strong></div>
          </div>
        </div>

        ${blocosDashboard}

        <div class="section">
          <div class="section-title">${this.escapeHtml(this.tituloTabela)}</div>
          <table class="grid">
            <thead>
              <tr>
                <th style="width:30px;">#</th>
                ${headersGrid}
              </tr>
            </thead>
            <tbody>
              ${linhasItens}
            </tbody>
          </table>
        </div>

        <div class="report-footer">
          <div>Impresso em: ${this.escapeHtml(this.formatarDataHora(new Date()))}</div>
          <div>Qtd. itens: ${this.escapeHtml(this.itens.length || 0)}</div>
          <div>Usuário: ${this.escapeHtml(nomeUsuario)}</div>
        </div>
      </body>
      </html>`
    },
    async imprimirEspelho() {
      const janela = window.open('', '_blank')
      if (!janela) {
        this.$bvToast.toast('O navegador bloqueou a abertura da nova aba do espelho.', {
          title: 'Aviso',
          variant: 'warning',
          solid: true
        })
        return
      }

      try {
        const empresa = await this.obterEmpresaPreferencial()
        const html = this.montarHtmlEspelho(empresa)
        janela.document.open('text/html', 'replace')
        janela.document.write(html)
        janela.document.close()
        janela.focus()
      } catch (err) {
        janela.close()
        this.$bvToast.toast('Erro ao gerar espelho da rastreabilidade', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    },
    voltar() {
      this.$router.push('/producao/formula-rastreabilidade/listagem')
    },
    async carregarTela() {
      this.isBusy = true
      try {
        await this.$store.dispatch('producaoFormulaRastreabilidade/GET_DETALHE', {
          tipo: this.tipoConsulta,
          id: this.id
        })
      } catch (err) {
        this.$bvToast.toast(err?.response?.data || 'Erro ao carregar o detalhamento da rastreabilidade', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
        this.voltar()
      } finally {
        this.isBusy = false
      }
    }
  }
}
</script>

<style scoped>
.trace-resume-card {
  border-radius: 12px;
  padding: 1rem 1.25rem;
  border: 1px solid rgba(0,0,0,0.08);
  min-height: 85px;
  background: white !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: transform 0.2s, box-shadow 0.2s;
}

.trace-resume-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04);
}

.trace-resume-card small {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d !important;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.trace-resume-card strong {
  font-size: 1.35rem;
  font-weight: 700;
  color: #2d3748;
}

.table-finance tbody td {
  vertical-align: middle !important;
}
</style>


// WEBPACK FOOTER //
// src/views/producao/producao-formula-rastreabilidade/ProducaoFormulaRastreabilidadeCadastro.vue